import styled, { css } from 'styled-components';

import { type CardSizes } from '@pkg/components';

export const Wrapper = styled.div<{ $cardSize?: CardSizes; $bordered?: boolean }>`
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
    width: 100%;
    height: 64px;
    overflow: hidden;
    padding: 0 12px 16px;
    border-bottom: ${({ $bordered }) => ($bordered ? '1px solid rgba(255, 255, 255, 0.1)' : 'none')};

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                height: 48px;
                padding: 0 8px 12px 8px;
                gap: 18px;
            `;
        }
    }}
`;

export const PriceGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1px;
`;

export const Label = styled.div<{ $cardSize?: CardSizes }>`
    font-weight: 500;

    font-size: 16px;
    line-height: 120%;
    letter-spacing: -0.03em;
    color: rgba(255, 255, 255, 0.5);

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                font-size: 12px;
            `;
        }
    }}
`;

export const PriceRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 3px;
`;

export const Price = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
`;

export const Icon = styled.div<{ $cardSize?: CardSizes }>`
    position: relative;
    top: 1px;
    svg {
        width: 12px;
    }

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                svg {
                    width: 10px;
                }
            `;
        }
    }}
`;

export const Value = styled.div<{ $cardSize?: CardSizes }>`
    font-weight: 700;
    font-size: 24px;
    line-height: 120%;
    color: #ffffff;

    ${({ $cardSize }) => {
        if ($cardSize === 'small') {
            return css`
                font-size: 16px;
            `;
        }
    }}
`;

export const Change = styled.div`
    position: relative;
    top: 1px;
`;

export const PercentLabel = styled.div<{ $isDesc?: boolean }>`
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    padding-bottom: 1px;
    color: ${({ $isDesc }) => ($isDesc ? '#ff004c' : 'rgba(98, 250, 113, 1)')};
    svg {
        width: 10px;
        height: 10px;
        fill: ${({ $isDesc }) => ($isDesc ? '#ff004c' : 'rgba(98, 250, 113, 1)')};
        transform: ${({ $isDesc }) => ($isDesc ? 'rotate(-180deg)' : 'initial')};
    }
`;
